import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { SessionService } from '../services/session.service';

@Injectable({
    providedIn: 'root'
})
export class AuthorizedUserGuard  {
    constructor(private router: Router, private sessionService: SessionService) { }

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.sessionService.isLoggedIn()) {
            return true;
        } else {
            return this.router.createUrlTree(['/']);
        }
    }
}
